import * as React from "react";
import type { SVGProps } from "react";

const SvgPencilIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11.001" {...props}>
        <path
            id="edit_enabled"
            data-name="edit enabled"
            d="M11.228,2.457a1.972,1.972,0,0,1,1.395,3.367L5.9,12.546a.564.564,0,0,1-.25.145l-2.738.747a.564.564,0,0,1-.693-.693l.747-2.738a.564.564,0,0,1,.145-.25L9.834,3.035A1.959,1.959,0,0,1,11.228,2.457ZM5.21,11.642l6.616-6.616a.844.844,0,1,0-1.194-1.194L4.016,10.449,3.568,12.09Z"
            transform="translate(-2.2 -2.457)"
            fill="currentColor"
        />
    </svg>
);
export default SvgPencilIcon;
